 
import SEO from "../../components/common/seo/SEO";
import CourseLandingPage from "../../components/Courses/CourseLandingPage/CourseLandingPage";
import catiaPythonCourse from "../../data/cad_section/catiaPythonCourse";

function CatiaPythonCoursePage() {
    return (
        <>
           <SEO
        title="CATIA Python Automation & Customization Training | CATIA Python Course | FeesWorth"

        description="Learn CATIA automation and customization using Python. Master CATIA Python scripting, CAD automation, part and assembly automation, drawing automation, and practical CATIA projects with expert training at FeesWorth."

        keywords="CATIA Python Training, CATIA Python Course, CATIA Automation Training, CATIA Customization Training, CATIA Python Automation, CATIA Scripting, CATIA Automation Course, CATIA Customization Course, CATIA API Python, CATIA Programming"

        canonical="https://feesworth.com/python-catia-automation-customization"
      />

            <CourseLandingPage course={catiaPythonCourse} />
        </>
    );
}

export default CatiaPythonCoursePage; 
